import { useState } from 'react';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../hooks/useAuth';
import { modalStyle } from '../../../../utils/modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Spinner } from '../../../../components/Spinner';
import { useEnv } from '../../../../context/env-context';
import { makeUploadRequest } from '../../../../utils/makeRequest';

function ProspectsUploadModal({ isOpen, close, aggregatorId, getAll }) {
  const { apiOriginAggregator } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [file, setFile] = useState(null);
  const [spinnerModal, setSpinnerModal] = useState(false);

  const handleFileChange = e => {
    if (e.target.files) {
      const targetFile = e.target.files[0];

      if (targetFile.type !== 'text/csv') {
        setFile('error');
      } else {
        setFile(targetFile);
      }
    }
  };

  const handleUploadClick = async () => {
    if (!file || file === 'error') {
      return;
    }

    const data = new FormData();

    data.append('file', file);
    data.append('aggregatorId', aggregatorId);

    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    setSpinnerModal(true);
    try {
      await makeUploadRequest(`${apiOriginAggregator}/prospects/upload`, data, token);

      toast.success('File uploaded successfully');
      setFile(null);
      close();
      await getAll();
    } catch (err) {
      setFile(null);
      toast.error(err.response.data.message.toString());
    } finally {
      setSpinnerModal(false);
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={modalStyle({})}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onRequestClose={close}
    >
      <Spinner visible={spinnerModal} text="">
        <h5>Upload prospects file:</h5>
        <Row className="mt-4">
          <Col>
            <Form.Control className="bo-file-chooser" type="file" onChange={handleFileChange} />
          </Col>
        </Row>
        {file === 'error' ? (
          <Row className="mt-3">
            <Col>
              <div className="bo-inline-error-large">
                <strong>Only csv files are allowed!</strong>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <Row className="mt-3">
              <Col>
                <div>
                  File name: <strong>{file && `${file.name}`}</strong>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  File type: <strong>{file && `${file.type}`}</strong>
                </div>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col className="d-flex justify-content-center gap-3 mt-3">
            <Button
              className="bo-button"
              disabled={!file || file === 'error'}
              onClick={handleUploadClick}
            >
              Upload
            </Button>
            <Button className="bo-button" onClick={close}>
              Close
            </Button>
          </Col>
        </Row>
      </Spinner>
    </ReactModal>
  );
}

export default ProspectsUploadModal;
